var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntersect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 688,
    height: 688,
    viewBox: "0 0 688 688",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M474.336 213.44V146.2C474.336 136.186 470.36 126.582 463.281 119.501L343.837 0L224.392 119.501C217.314 126.582 213.337 136.186 213.337 146.2V213.44L146.134 213.441C136.123 213.441 126.523 217.42 119.445 224.501L0 344.002L119.445 463.501C126.523 470.582 136.123 474.561 146.134 474.561H213.337V541.798C213.337 551.814 217.314 561.418 224.392 568.5L343.837 688L463.281 568.5C470.36 561.418 474.336 551.814 474.336 541.8V474.56L474.313 474.51L474.66 474.561H541.867C551.877 474.561 561.477 470.582 568.555 463.501L688 344.002L568.555 224.501C561.477 217.42 551.877 213.441 541.867 213.441H474.66L474.26 213.684L474.336 213.44Z",
    fill: "#4DFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersect);
export default __webpack_public_path__ + "static/media/intersect.2c3ee3a5c596e17f71f00e3b935761bb.svg";
export { ForwardRef as ReactComponent };